<mat-accordion [@quickFade] *ngIf="progressTimetableService.length > 0">
  <mat-expansion-panel
    [expanded]="expanded"
    (opened)="toggleExpand(true)"
    (closed)="toggleExpand(false)">
    <mat-expansion-panel-header
      matRipple
      collapsedHeight="48px"
      expandedHeight="48px">
      <mat-panel-title>
        Timetable Actions {{ progressTimetableService.completed }} of
        {{ progressTimetableService.length }} completed
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="content">
      <app-progress-timetable-item
        *ngFor="let item of progressTimetableService.list; trackBy: trackItem"
        [@quickFade]
        [id]="item.id"
        [route]="item.route"
        [filename]="item.filename"
        [started]="item.started"
        [progress]="item.progress"
        [error]="item.error"
        [rejected]="item.rejected"
        [message]="item.statusMessage"
        (clickEvent)="progressTimetableService.remove($event)"
        [completed]="item.completed"></app-progress-timetable-item>
    </div>
    <div fxLayout="row" fxLayoutAlign="flex-end center">
      <button mat-button (click)="progressTimetableService.removeCompleted()">
        Clear
      </button>
    </div>
  </mat-expansion-panel>
</mat-accordion>
